import {
    requestAllProducts,
    requestSaveProduct,
    requestDeleteProduct
} from "@/api/product-api";

const actions = {

    async getAllProducts({commit}, data) {
        let result = await requestAllProducts(data)
        if (result.code === '200') {
            return result
        } else {
            return Promise.reject(new Error('無法取得資料'))
        }
    },

    async saveProduct({commit}, data) {
        let result = await requestSaveProduct(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('資料更新失敗'))
        }
    },

    async deleteProduct({commit}, data) {
        let result = await requestDeleteProduct(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('資料刪除失敗'))
        }
    }
}

const mutations = {}
const state = {}
const getters = {}

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters
}
